import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getBlockchainLists({ commit }, params) {
    return api.home
      .getSubscribeQueryList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_BLOCK_CHAIN, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  getBlockContractLists({ commit }, params) {
    return api.chain
      .getBlockContractList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_BLOCK_CONTRACT, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  getUpperChainLists({ commit }, params) {
    return api.chain
      .getUpperChainList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_UPPER_CHAIN, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  getChainOrgLists({ commit }, params) {
    return api.chain
      .getChainOrgList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_CHAIN_ORG, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  getChainNodeLists({ commit }, params) {
    return api.chain
      .getChainNodeList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_CHAIN_NODE, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  //链下扩容
  getOffchainNodeLists({ commit }, params) {
    return api.chain
      .getOffchainNodeList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_OFFCHAIN_NODE, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },

  //链下扩容通道
  getOffchainChanLists({ commit }, params) {
    return api.chain
      .getOffchainChanList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_OFFCHAIN_CHAN_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },

  // 获取用户管理的数据
  getUserLists({ commit }, params) {
    return api.chain
      .getUserList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_CHAIN_USER, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },

  getVoteLists({ commit }, params) {
    return api.chain
      .getVoteList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_CHAIN_VOTE, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  updateActiveTab({ commit }, params) {
    commit(TYPES.UPDATE_ACTIVE_TAB, params)
  },

  getActiveUserId({ commit }, params) {
    commit(TYPES.GET_ACTIVE_USERID, params)
  },

  updateArchivingInfo({ commit }, params) {
    commit(TYPES.GET_ARCHIVING_DETAIL, params)
  }
}
